import { InfoSysoptsResp } from 'app/bff/models/info/infoSysopts';
import { InfoGetmsgtextResp } from 'app/bff/models/info/infoGetmsgtext';
import { InfoAddressGetcityareaResp } from 'app/bff/models/info/infoAddressGetcityarea';
import { InfoGetnationlistResp, DataResp } from 'app/bff/models/info/infoGetnationlist';
import { InfoBanklistResp } from 'app/bff/models/info/infoBanklist';
import { InfoGetlinkUrlResp } from 'app/bff/models/info/infoGetlinkUrl';
import { InfoSysparamsResp } from 'app/bff/models/info/infoSysparams';
import { AaOtpVerifyResp } from 'app/bff/models/aa/aaOtpVerify';
import { AaSigninResp } from 'app/bff/models/aa/aaSignin';
import { MbGetinfoReq, MbGetinfoResp } from 'app/bff/models/mb/mbGetinfo';
import { MbSigninResp } from 'app/bff/models/mb/mbSignin';
import { InfoJobResp } from '../../bff/models/info/infoJob';

// State type
export interface CommonState {
  member: MemberState;
  systemParameters: InfoSysparamsResp['enum'];
  systemOptions: InfoSysoptsResp['enum'];
  systemMessages: InfoGetmsgtextResp['msgList'];
  postcodes: InfoAddressGetcityareaResp['postcodes'];
  getnationList: InfoGetnationlistResp['countries'];
  countries: DataResp[];
  nativeCountry: DataResp | null;
  foreignCountries: DataResp[];
  relationshipPrecedenceOptions: InfoSysoptsResp['enum'];
  relationshipProportionOptions: InfoSysoptsResp['enum'];
  relationshipPrecedenceU7Options: InfoSysoptsResp['enum'];
  relationshipProportionU7Options: InfoSysoptsResp['enum'];
  bankList: InfoBanklistResp['bank'];
  links: InfoGetlinkUrlResp;
  baseUrls: InfoSysparamsResp['enum'];
  jobs: InfoJobResp['jobs'];
}

interface MemberState {
  authorization: AaOtpVerifyResp | AaSigninResp | MbSigninResp | null;
  profile?: MbGetinfoResp;
}
// ::: End

// Actions type constant
export const COMMON__INIT_FETCH_COMMON_DATA = 'COMMON__INIT_FETCH_COMMON_DATA';
export const COMMON__INIT_FETCH_COMMON_DATA_DONE = 'COMMON__INIT_FETCH_COMMON_DATA_DONE';
export const COMMON__SAVE_MEMBER_AUTHORIZATION = 'COMMON__SAVE_MEMBER_AUTHORIZATION';
export const COMMON__FETCH_MEMBER_PROFILE = 'COMMON__FETCH_MEMBER_PROFILE';
export const COMMON__FETCH_MEMBER_PROFILE_DONE = 'COMMON__FETCH_MEMBER_PROFILE_DONE';
export const COMMON__RESET_MEMBER_CACHE = 'COMMON__RESET_MEMBER_CACHE';
// ::: End

// Action creators type
export interface InitFetchCommonDataAction {
  type: typeof COMMON__INIT_FETCH_COMMON_DATA;
}

export interface InitFetchCommonDataDoneAction {
  type: typeof COMMON__INIT_FETCH_COMMON_DATA_DONE;
  payload: {
    response: CommonState;
  };
}

export interface SaveMemberAuthorizationAction {
  type: typeof COMMON__SAVE_MEMBER_AUTHORIZATION;
  payload: {
    authorization: AaOtpVerifyResp | AaSigninResp | MbSigninResp;
  };
}

export interface FetchMemberProfileAction {
  type: typeof COMMON__FETCH_MEMBER_PROFILE;
  payload: {
    args: MbGetinfoReq;
  };
}

export interface FetchMemberProfileDoneAction {
  type: typeof COMMON__FETCH_MEMBER_PROFILE_DONE;
  payload: {
    response: MbGetinfoResp;
  };
}

export interface ResetMemberCacheAction {
  type: typeof COMMON__RESET_MEMBER_CACHE;
}

export type CommonActions =
    InitFetchCommonDataAction
  | InitFetchCommonDataDoneAction
  | SaveMemberAuthorizationAction
  | FetchMemberProfileAction
  | FetchMemberProfileDoneAction
  | ResetMemberCacheAction;
// ::: End
